// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 15 12\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#EB4962\" d=\"M0 11.7h14.65L7.32 4.39z\"/><path fill=\"#03363D\" d=\"M7.34 0l-3.3 3.29h6.58z\"/></g></svg>";
// Exports
module.exports = code;